exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1hlHK{z-index:122;right:-333px;top:0}._1hlHK,.e3SJp{position:absolute}.e3SJp{width:0;height:0;border-style:solid;border-color:transparent #fff transparent transparent;top:20px;border-width:12px 12px 12px 0;left:-12px}", ""]);

// exports
exports.locals = {
	"root": "_1hlHK",
	"corner": "e3SJp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/ToolTipWrapper/ToolTipWrapper.css
// module id = 1718
// module chunks = 15 20 21 23 32 33 38